'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useProductFruits = useProductFruits;
exports.selectIsProductFruitsReady = selectIsProductFruitsReady;

var _react = require('react');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * 
 * @param {*} callback 
 * @returns 
 */
function useProductFruits(callback, deps) {
    var _deps = (0, _react.useMemo)(function () {
        return [].concat(_toConsumableArray(deps));
    }, [deps]);

    (0, _react.useEffect)(function () {
        if (typeof window === 'undefined') return;

        window.productFruitsReady = function () {
            callback(window.productFruits.api);
        };

        if (window.productFruitsIsReady && window.productFruits && window.productFruits.api) {
            callback(window.productFruits.api);
        }
    }, [_deps, callback]);
}

/**
 * 
 * @returns {boolean}
 */
function selectIsProductFruitsReady() {
    if (typeof window === 'undefined') return false;

    return window.productFruitsIsReady === true;
}